//CSSをバンドル
import 'Src/scss/faq.scss'
//共通のJavaScriptを読み込み
import 'Src/js/utils/utils'



//質問クリック時
$('.faqContents__q').on('click', function() {

  $(this).next('.faqContents__a').slideToggle();

  //矢印の向き
  if( $(this).hasClass('rotate') ) {
    $(this).removeClass('rotate');
  } else {
    $(this).addClass('rotate');
  }
  
});
